import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import Table from "react-bootstrap/Table";

function CreateDriver({ clientID, autoData }) {
  const [formData, setFormData] = useState({
    createActivated: false,
    firstName: "",
    lastName: "",
    dob: "",
    license: "",
    activeOnPolicy: true,
    policies: null,
    parentPolicy: ""
  });

  useEffect(() => {
    setTimeout(() => {
      getPolicies(clientID);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const getPolicies = (id) => {
    API.findClientsAutoPolicies(id).then((res) => {
      setFormData((prev) => ({
        ...prev,
        policies: res.data
      }));
    });
  };

  const handleDriverSubmit = (e) => {
    e.preventDefault();

    API.saveDriver(autoData[0]._id, {
      firstName: formData.firstName,
      lastName: formData.lastName,
      dob: formData.dob,
      license: formData.license,
      parentPolicy: formData.parentPolicy,
      active: true
    })
      .then((_res) => {
        alert("You've saved the Driver");
      })
      .catch((_err) =>
        alert("WARNING, DRIVER NOT SAVED. PLEASE TRY AGAIN, IF ERROR PERSISTS CALL 610-299-9918")
      );
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="card-header">Create a Driver</div>
        <div className="card-body">
          <Table>
            <tbody>
              <tr>
                <th>
                  <strong>Info needed</strong>
                </th>
                <th>
                  <strong>Input</strong>
                </th>
              </tr>
              <tr>
                <td>First Name: </td>
                <td>
                  <input
                    type="text"
                    onChange={handleInputChange}
                    value={formData.firstName}
                    name="firstName"
                  />
                </td>
              </tr>
              <tr>
                <td>Last Name: </td>
                <td>
                  <input
                    type="text"
                    onChange={handleInputChange}
                    value={formData.lastName}
                    name="lastName"
                  />
                </td>
              </tr>
              <tr>
                <td>Policy Assignment</td>
                {formData.policies ? (
                  <td>
                    <select
                      id="protegeDropMenu"
                      value={formData.parentPolicy}
                      onChange={handleInputChange}
                      name="parentPolicy"
                      type=""
                    >
                      <option value="">--Select a Policy--</option>
                      {formData.policies.map((policy) => (
                        <option key={policy._id} value={policy._id}>
                          {policy.carrier} #{policy.policyNumber}
                        </option>
                      ))}
                    </select>
                  </td>
                ) : (
                  <td>"No auto policies yet"</td>
                )}
              </tr>
            </tbody>
          </Table>
          <button
            style={{ textAlign: "center" }}
            className="btn btn-success"
            onClick={handleDriverSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateDriver;
